import { render } from "./EmployeeSalary.vue?vue&type=template&id=1687aafd"
import script from "./EmployeeSalary.vue?vue&type=script&lang=js"
export * from "./EmployeeSalary.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hr.tomorrow.services/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__